import React, { useState, useContext } from "react";
import { Typography } from "@material-ui/core";
import { Box } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Container } from "@material-ui/core";
import { FormControl } from "@material-ui/core";
import { FormLabel } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { FormContext } from "../../util/context";
import { RadioGroup } from "@material-ui/core";
import { FormControlLabel } from "@material-ui/core";
import { Radio } from "@material-ui/core";

const HeightandWeight = () => {
  const [form, setForm] = useContext(FormContext);
  const [system, setSystem] = useState("ft/lbs");

  const handleChange = (event) => {
    setSystem(event.target.value);
    console.log(event.target.value);
  };

  const onImperial = () => {
    const height = form.imperial.feet * 30.48 + form.imperial.inches * 2.54;
    const weight = form.imperial.lbs / 2.205;
    setForm({ ...form, height: height, weight: weight, count: form.count + 1 });

    console.log("height", height, "weight", weight);
  };

  const onMetric = () => {
    const height = form.metric.cm;
    const weight = form.metric.kg;
    setForm({ ...form, height: height, weight: weight, count: form.count + 1 });
    console.log("height", height, weight);
  };

  return (
    <>
      <Container maxWidth="xs">
        <Box paddingLeft={10}>
          <Typography align="center" component={"span"} variant="h4">
            Height & Weight
          </Typography>
        </Box>
      </Container>
      <Container maxWidth="sm">
        <Box mt={5}>
          <Container maxWidth="md">
            <FormControl size="medium">
              <Grid container={true} spacing={2}>
                <Grid item={true} xs={12}>
                  <Typography>
                    Choose the measurement system you prefer
                  </Typography>
                </Grid>
                <Grid item={true} xs={12}>
                  <FormControl size="medium">
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      value={system}
                      name="radio-buttons-group"
                      onChange={handleChange}
                    >
                      <FormControlLabel
                        value="ft/lbs"
                        control={<Radio color="primary" />}
                        label="ft/lbs"
                      />
                      <FormControlLabel
                        value="cm/kg"
                        control={<Radio color="primary" />}
                        label="cm/kg"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                {system === "ft/lbs" && (
                  <>
                    <Grid item={true} xs={6}>
                      <FormLabel id="outlined-multiline-flexible">
                        <Typography variant="subtitle1" component={"span"}>
                          Feet
                        </Typography>
                      </FormLabel>
                      <TextField
                        id="outlined-multiline-flexible"
                        variant="outlined"
                        type="number"
                        placeholder="5"
                        value={form.imperial.feet}
                        fullWidth={true}
                        onChange={(event) => {
                          setForm((before) => ({
                            ...before,
                            imperial: {
                              ...before.imperial,
                              feet: event.target.value,
                            },
                          }));
                        }}
                      />
                    </Grid>
                    <Grid item={true} xs={6}>
                      <FormLabel id="Inches">
                        <Typography variant="subtitle1" component={"span"}>
                          Inches
                        </Typography>
                      </FormLabel>
                      <TextField
                        id="Inches"
                        variant="outlined"
                        type="number"
                        placeholder="9"
                        value={form.imperial.inches}
                        fullWidth={true}
                        onChange={(event) => {
                          setForm((before) => ({
                            ...before,
                            imperial: {
                              ...before.imperial,
                              inches: event.target.value,
                            },
                          }));
                        }}
                      />
                    </Grid>
                    <Grid item={true} xs={12}>
                      <FormLabel id="Weight">
                        <Typography variant="subtitle1" component={"span"}>
                          Weight (lbs)
                        </Typography>
                      </FormLabel>
                      <TextField
                        id="Weight"
                        variant="outlined"
                        type="number"
                        placeholder="165"
                        value={form.imperial.lbs}
                        fullWidth={true}
                        onChange={(event) => {
                          setForm((before) => ({
                            ...before,
                            imperial: {
                              ...before.imperial,
                              lbs: event.target.value,
                            },
                          }));
                        }}
                      />
                    </Grid>
                    <Grid item={true} xs={12}>
                      <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        onClick={onImperial}
                      >
                        Next
                      </Button>
                    </Grid>
                  </>
                )}
                {system === "cm/kg" && (
                  <>
                    <Grid item={true} xs={12}>
                      <FormLabel id="Cm">
                        <Typography variant="subtitle1" component={"span"}>
                          Centimetres
                        </Typography>
                      </FormLabel>
                      <TextField
                        id="Cm"
                        variant="outlined"
                        type="number"
                        placeholder="170"
                        value={form.metric.cm}
                        fullWidth={true}
                        onChange={(event) => {
                          setForm((before) => ({
                            ...before,
                            metric: {
                              ...before.metric,
                              cm: event.target.value,
                            },
                          }));
                        }}
                      />
                    </Grid>
                    <Grid item={true} xs={12}>
                      <FormLabel id="kg">
                        <Typography variant="subtitle1" component={"span"}>
                          Kilograms
                        </Typography>
                      </FormLabel>
                      <TextField
                        id="kg"
                        variant="outlined"
                        type="number"
                        placeholder="60"
                        value={form.metric.kg}
                        fullWidth={true}
                        onChange={(event) => {
                          setForm((before) => ({
                            ...before,
                            metric: {
                              ...before.metric,
                              kg: event.target.value,
                            },
                          }));
                        }}
                      />
                    </Grid>
                    <Grid item={true} xs={12}>
                      <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        onClick={onMetric}
                      >
                        Next
                      </Button>
                    </Grid>
                  </>
                )}
              </Grid>
            </FormControl>
          </Container>
        </Box>
      </Container>
    </>
  );
};

export default HeightandWeight;
